// extracted by mini-css-extract-plugin
export default {"emoji_container":"EmojiInput_emoji_container__P-7Ql","emoji_dialog":"EmojiInput_emoji_dialog__WgUhV","emoji_btn":"EmojiInput_emoji_btn__Z-wgT"};